import dashboardService from "../../services/dashboardService";

const { addDashboard, updateDashboard, updateDashboardShared } = dashboardService;

async function updateSharedDashboardForm(data, dashboard_channel_id) {
    delete data.bot_id;
    delete data.company_ids;
    data.dashboard_channel_id = dashboard_channel_id;
    const [response, errors] = await updateDashboardShared(dashboard_channel_id,data);
    if (errors != null) {
        console.log(errors)
        return;
    }
    return '/dashboards/list';
}

async function addDashboardForm(data) {
    const [response, errors] = await addDashboard(data);
    if (errors != null) {
        console.log(errors)
        return;
    }
    return '/dashboard/editor/' + response.id;
}

async function updateDashboardForm(data, dashboard_channel_id) {
    console.log(data);
    data.dashboard_channel_id = dashboard_channel_id;
    const [response, errors] = await updateDashboard(dashboard_channel_id,data);
    if (errors != null) {
        console.log(errors)
        return;
    }
    return '/dashboards/list';
}


export { updateSharedDashboardForm, addDashboardForm, updateDashboardForm }